<template>
  <div>
    <ProductSettingsSellables
      v-if="currentMode === Mode.SELLABLES"
      @on-back="emit('onClose')"
      @add-new="switchToCatalogMode"
      @edit="openProductTypeSettings"
    />
    <ProductSettingsCatalog
      v-else-if="currentMode === Mode.CATALOG"
      @on-back="switchToSellablesMode"
      @add-new="openProductTypeSettings"
    />
  </div>
</template>

<script setup lang="ts">
import { ref } from 'vue';
import ProductSettingsSellables from './ProductSettingsSellables.vue';
import ProductSettingsCatalog from './ProductSettingsCatalog.vue';
import ProductSettingsProductDialog from './ProductSettingsProductDialog.vue';
import dialogService from 'commons/dialogs/wrapper/dialogService';

enum Mode {
  SELLABLES = 'SELLABLES',
  CATALOG = 'CATALOG',
}

const emit = defineEmits<{
  onClose: [];
  onDismiss: [];
}>();

const currentMode = ref<Mode>(Mode.SELLABLES);

const switchToCatalogMode = () => {
  currentMode.value = Mode.CATALOG;
};

const switchToSellablesMode = () => {
  currentMode.value = Mode.SELLABLES;
};

const openProductTypeSettings = (
  productTypeId: number,
  appearanceId?: number,
) => {
  dialogService
    .openDialog(
      ProductSettingsProductDialog,
      {
        productTypeId,
        backLabel:
          currentMode.value === Mode.SELLABLES
            ? 'PUBLISHING.DETAIL.PRODUCTS.ADVANCED.BACK_TO_SELLABLES'
            : 'PUBLISHING.DETAIL.PRODUCTS.ADVANCED.BACK_TO_CATALOG',
        appearanceId,
      },
      {
        fullSize: true,
      },
    )
    .then(
      () => {
        // always return to sellables mode after product settings dialog is closed aka saved
        currentMode.value = Mode.SELLABLES;
      },
      () => {},
    );
};
</script>

<style lang="scss" scoped>
@import 'src/scss/styleguide/colors';
@import 'src/scss/styleguide/links';

.product-settings {
  margin: 24px 0 0 0;
  padding: 0 24px;
  width: 100%;
}
</style>
